import { Injectable } from '@angular/core';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { Observable } from 'rxjs';
import * as grpcWeb from 'grpc-web';
import { PlaceConversionService } from '../../conversion/place/place-conversion.service';
import { GolfTeacherConversionService } from '../../conversion/golf_class/golfteacher-conversion.service';
import { Empty, GolfTeacher } from 'src/app/libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class GrpcGolfTeacherLibService {

  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: GolfTeacherConversionService,
  ) { }

  getGolfTeachers(option?: GrpcLibServiceOption): Promise<GolfTeacher[]>{
    return new Observable<GolfTeacher[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getGolfTeachersOffline(opt);
      } else {
        this._getGolfTeachersOnline(opt);
      }

    }).toPromise();
  }

  private _getGolfTeachersOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('g-teacher-s') || this.storLib.get('g-teacher')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getGolfTeachersOnline(option: GrpcLibServiceOption){
    this.grpcLib.MobileClient.getGolfTeachers(new Empty(), {
        token: this.userLib.Data.token?.getToken(),
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getGolfTeachersOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getGolfTeachersOnlineStatus(s, option);
      })
      .on('data', (r: GolfTeacher) => {
        this._getGolfTeachersOnlineData(r, option);
      })
      .on('end', () => {
        this._getGolfTeachersOnlineEnd(option);
      });
  }

  private _getGolfTeachersOnlineData(ret: GolfTeacher, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getGolfTeachersOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getGolfTeachersOnline(option);
    }, option);
  }

  private _getGolfTeachersOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getGolfTeachersOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.golfTeacher = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'g-teacher', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }
    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getGolfTeachersOnline(option);
      }, option);
    }
  }
}
